module.exports = __webpack_public_path__ + "7c115bf7df1836d507144cea748d0ea5.fbx";